/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */
export const REQUESTED_HISTORY = 'REQUESTED_HISTORY';
export const requestedHistory = (beginDate, endDate) => {
  return {
    type: REQUESTED_HISTORY,
    beginDate,
    endDate
  };
};

export const RECEIVED_HISTORY = 'RECEIVED_HISTORY';
export const receivedHistory = (history) => {
  return {
    type: RECEIVED_HISTORY,
    history
  };
};

export const ERROR_HISTORY = 'ERROR_HISTORY';
export const errorHistory = (error, beginDate, endDate) => {
  return {
    type: ERROR_HISTORY,
    error,
    beginDate,
    endDate
  };
};

export const REQUESTED_YTD_DATA = 'REQUESTED_YTD_DATA';
export const requestedYTDBalanceData = (beginDate, endDate) => {
  return {
    type: REQUESTED_YTD_DATA,
    beginDate,
    endDate
  };
};

export const RECEIVED_YTD_DATA = 'RECEIVED_YTD_DATA';
export const receivedYTDBalanceData = (ytdData) => {
  return {
    type: RECEIVED_YTD_DATA,
    ytdData
  };
};

export const ERROR_YTD_DATA = 'ERROR_YTD_DATA';
export const errorYTDBalanceData = (error) => {
  return {
    type: ERROR_YTD_DATA,
    error
  };
};

export const REQUESTED_ACCOUNT_GROWTH = 'REQUESTED_ACCOUNT_GROWTH';
export const requestedAccountGrowth = (beginDate, endDate) => {
  return {
    type: REQUESTED_ACCOUNT_GROWTH,
    beginDate,
    endDate
  };
};

export const RECEIVED_ACCOUNT_GROWTH = 'RECEIVED_ACCOUNT_GROWTH';
export const receivedAccountGrowth = (growth) => {
  return {
    type: RECEIVED_ACCOUNT_GROWTH,
    growth
  };
};

export const ERROR_ACCOUNT_GROWTH = 'ERROR_ACCOUNT_GROWTH';
export const errorAccountGrowth = (error, beginDate, endDate) => {
  return {
    type: ERROR_ACCOUNT_GROWTH,
    error,
    beginDate,
    endDate
  };
};

export const REQUESTED_INDIVIDUAL_ACCOUNT_GROWTH =
  'REQUESTED_INDIVIDUAL_ACCOUNT_GROWTH';
export const requestedIndividualAccountGrowth = (accountId) => {
  return {
    type: REQUESTED_INDIVIDUAL_ACCOUNT_GROWTH,
    payload: { accountId }
  };
};

export const RECEIVED_INDIVIDUAL_ACCOUNT_GROWTH =
  'RECEIVED_INDIVIDUAL_ACCOUNT_GROWTH';
export const receivedIndividualAccountGrowth = (growth) => {
  return {
    type: RECEIVED_INDIVIDUAL_ACCOUNT_GROWTH,
    growth
  };
};

export const ERROR_INDIVIDUAL_ACCOUNT_GROWTH =
  'ERROR_INDIVIDUAL_ACCOUNT_GROWTH';
export const errorIndividualAccountGrowth = (error, accountId) => {
  return {
    type: ERROR_INDIVIDUAL_ACCOUNT_GROWTH,
    error: true,
    payload: {
      accountId,
      error
    }
  };
};

export const REQUESTED_CONSOLIDATED_PERFORMANCE =
  'REQUESTED_CONSOLIDATED_PERFORMANCE';
export const requestedConsolidatedPerformance = () => {
  return {
    type: REQUESTED_CONSOLIDATED_PERFORMANCE
  };
};

export const RECEIVED_CONSOLIDATED_PERFORMANCE =
  'RECEIVED_CONSOLIDATED_PERFORMANCE';
export const receivedConsolidatedPerformance = (
  accountPerformanceAggregate
) => {
  return {
    type: RECEIVED_CONSOLIDATED_PERFORMANCE,
    accountPerformanceAggregate
  };
};

export const ERROR_CONSOLIDATED_PERFORMANCE = 'ERROR_CONSOLIDATED_PERFORMANCE';
export const errorConsolidatedPerformance = (error) => {
  return {
    type: ERROR_CONSOLIDATED_PERFORMANCE,
    error
  };
};

export const REQUESTED_PRODUCT_PERFORMANCE = 'REQUESTED_PRODUCT_PERFORMANCE';
export const requestedProductPerformance = (accountNumbers) => {
  return {
    type: REQUESTED_PRODUCT_PERFORMANCE,
    accountNumbers
  };
};

export const RECEIVED_PRODUCT_PERFORMANCE = 'RECEIVED_PRODUCT_PERFORMANCE';
export const receivedProductPerformance = (productPerformance) => {
  return {
    type: RECEIVED_PRODUCT_PERFORMANCE,
    productPerformance
  };
};

export const ERROR_PRODUCT_PERFORMANCE = 'ERROR_PRODUCT_PERFORMANCE';
export const errorProductPerformance = (error, accountNumbers) => {
  return {
    type: ERROR_PRODUCT_PERFORMANCE,
    error,
    accountNumbers
  };
};

export const REQUESTED_AGGREGATED_PRODUCT_PERFORMANCE =
  'REQUESTED_AGGREGATED_PRODUCT_PERFORMANCE';
export const requestedAggregatedProductPerformance = (accountNumbers) => {
  return {
    type: REQUESTED_AGGREGATED_PRODUCT_PERFORMANCE,
    accountNumbers
  };
};

export const RECEIVED_AGGREGATED_PRODUCT_PERFORMANCE =
  'RECEIVED_AGGREGATED_PRODUCT_PERFORMANCE';
export const receivedAggregatedProductPerformance = (productPerformance) => {
  return {
    type: RECEIVED_AGGREGATED_PRODUCT_PERFORMANCE,
    productPerformance
  };
};

export const ERROR_AGGREGATED_PRODUCT_PERFORMANCE =
  'ERROR_AGGREGATED_PRODUCT_PERFORMANCE';
export const errorAggregatedProductPerformance = (error, accountNumbers) => {
  return {
    type: ERROR_AGGREGATED_PRODUCT_PERFORMANCE,
    error,
    accountNumbers
  };
};

export const PREFILTER_ACCOUNTS = 'PREFILTER_ACCOUNTS';
export const preFilterAccounts = (
  all,
  subset = {},
  accountsWithProductType = []
) => {
  return {
    type: PREFILTER_ACCOUNTS,
    all,
    subset,
    accounts: accountsWithProductType
  };
};

export const SELECTED_ACCOUNT_FILTER = 'SELECTED_ACCOUNT_FILTER';
export const selectedAccountFilter = (accountFilter) => {
  return {
    type: SELECTED_ACCOUNT_FILTER,
    accountFilter
  };
};

export const SELECTED_MANAGEMENT_FILTER = 'SELECTED_MANAGEMENT_FILTER';
export const selectedManagementFilter = (managementTypeFilterSelection) => {
  return {
    type: SELECTED_MANAGEMENT_FILTER,
    managementTypeFilterSelection
  };
};

export const MOBILE_SELECTED_ACCOUNT_FILTER = 'MOBILE_SELECTED_ACCOUNT_FILTER';
export const mobileSelectedAccountFilter = (accountFilter) => {
  return {
    type: MOBILE_SELECTED_ACCOUNT_FILTER,
    accountFilter
  };
};
//
// export const SELECTED_PERIOD = 'SELECTED_PERIOD';
// export const selectedPeriod = (period, filterType) => {
//   return {
//     type: SELECTED_PERIOD,
//     period,
//     filterType
//   };
// };

export const SET_CUSTOM_RANGE_FLAG = 'SET_CUSTOM_RANGE_FLAG';
export const setCustomRangeFlag = (customRangeFlag) => {
  return {
    type: SET_CUSTOM_RANGE_FLAG,
    customRangeFlag
  };
};

export const SET_FROM_DATE = 'SET_FROM_DATE';
export const setFromDate = (fromDate) => {
  return {
    type: SET_FROM_DATE,
    fromDate
  };
};

export const SET_TO_DATE = 'SET_TO_DATE';
export const setToDate = (toDate) => {
  return {
    type: SET_TO_DATE,
    toDate
  };
};

export const MOBILE_SELECTED_PERIOD = 'MOBILE_SELECTED_PERIOD';
export const mobileSelectedPeriod = (period) => {
  return {
    type: MOBILE_SELECTED_PERIOD,
    period
  };
};

export const TOGGLED_PURPOSE = 'TOGGLED_PURPOSE';
export const toggledPurpose = (purpose) => {
  return {
    type: TOGGLED_PURPOSE,
    purpose
  };
};

export const MOBILE_TOGGLED_PURPOSE = 'MOBILE_TOGGLED_PURPOSE';
export const mobileToggledPurpose = (purpose) => {
  return {
    type: MOBILE_TOGGLED_PURPOSE,
    purpose
  };
};

export const TOGGLED_ALL_PURPOSES = 'TOGGLED_ALL_PURPOSES';
export const toggledAllPurposes = () => {
  return {
    type: TOGGLED_ALL_PURPOSES
  };
};

export const TOGGLED_PRODUCT = 'TOGGLED_PRODUCT';
export const toggledProduct = (product) => {
  return {
    type: TOGGLED_PRODUCT,
    product
  };
};

export const MOBILE_TOGGLED_PRODUCT = 'MOBILE_TOGGLED_PRODUCT';
export const mobileToggledProduct = (product) => {
  return {
    type: MOBILE_TOGGLED_PRODUCT,
    product
  };
};

export const TOGGLED_ALL_PRODUCTS = 'TOGGLED_ALL_PRODUCTS';
export const toggledAllProducts = () => {
  return {
    type: TOGGLED_ALL_PRODUCTS
  };
};

export const MOBILE_TOGGLED_CHANGE_FILTERS = 'MOBILE_TOGGLED_CHANGE_FILTERS';
export const mobileToggledChangeFilters = () => {
  return {
    type: MOBILE_TOGGLED_CHANGE_FILTERS
  };
};

export const SET_MOBILE_FILTERS = 'SET_MOBILE_FILTERS';
export const setMobileFilters = () => {
  return {
    type: SET_MOBILE_FILTERS
  };
};

export const TOGGLED_PRR_CHART = 'TOGGLED_PRR_CHART';
export const toggledPrrChart = (prrChart) => {
  return {
    type: TOGGLED_PRR_CHART,
    prrChart
  };
};

export const REQUESTED_GIFT_INDICATORS = 'REQUESTED_GIFT_INDICATORS';
export const requestedGiftIndicators = () => {
  return {
    type: REQUESTED_GIFT_INDICATORS
  };
};

export const RECEIVED_GIFT_INDICATORS = 'RECEIVED_GIFT_INDICATORS';
export const receivedGiftIndicators = (giftingindicators) => ({
  type: RECEIVED_GIFT_INDICATORS,
  giftingindicators
});

export const ERROR_GIFT_INDICATORS = 'ERROR_GIFT_INDICATORS';
export const errorGiftIndicators = (error) => ({
  type: ERROR_GIFT_INDICATORS,
  error
});

export const REQUESTED_VIDEO_ELIGIBILITIES = 'REQUESTED_VIDEO_ELIGIBILITIES';
export const requestedVideoEligibilities = () => {
  return {
    type: REQUESTED_VIDEO_ELIGIBILITIES
  };
};

export const RECEIVED_VIDEO_ELIGIBILITIES = 'RECEIVED_VIDEO_ELIGIBILITIES';
export const receivedVideoEligibilities = (videoeligibilities) => ({
  type: RECEIVED_VIDEO_ELIGIBILITIES,
  videoeligibilities
});

export const ERROR_VIDEO_ELIGIBILITIES = 'ERROR_VIDEO_ELIGIBILITIES';
export const errorVideoEligibilities = (error) => ({
  type: ERROR_VIDEO_ELIGIBILITIES,
  error
});

export const REQUESTED_INTRADAY_PRICING_MANUAL =
  'REQUESTED_INTRADAY_PRICING_MANUAL';
export const requestedIntradayPricingManual = () => ({
  type: REQUESTED_INTRADAY_PRICING_MANUAL
});

export const REQUESTED_INTRADAY_PRICING_AUTOMATIC =
  'REQUESTED_INTRADAY_PRICING_AUTOMATIC';
export const requestedIntradayPricingAutomatic = () => ({
  type: REQUESTED_INTRADAY_PRICING_AUTOMATIC
});

export const RECEIVED_INTRADAY_PRICING_MANUAL =
  'RECEIVED_INTRADAY_PRICING_MANUAL';
export const receivedIntradayPricingManual = (response) => ({
  type: RECEIVED_INTRADAY_PRICING_MANUAL,
  accounts: [...response]
});

export const RECEIVED_INTRADAY_PRICING_AUTOMATIC =
  'RECEIVED_INTRADAY_PRICING_AUTOMATIC';
export const receivedIntradayPricingAutomatic = (response) => ({
  type: RECEIVED_INTRADAY_PRICING_AUTOMATIC,
  accounts: [...response]
});

export const UPDATE_INTRADAY_ACCOUNTS = 'UPDATE_INTRADAY_ACCOUNTS';
export const updateIntradayAccountStatus = (payload) => ({
  type: UPDATE_INTRADAY_ACCOUNTS,
  payload: {
    payloadData: payload
  }
});

export const ERROR_INTRADAY_PRICING_MANUAL = 'ERROR_INTRADAY_PRICING_MANUAL';
export const errorIntradayPricingManual = (error) => ({
  type: ERROR_INTRADAY_PRICING_MANUAL,
  error
});

export const ERROR_INTRADAY_PRICING_AUTOMATIC =
  'ERROR_INTRADAY_PRICING_AUTOMATIC';
export const errorIntradayPricingAutomatic = (error) => ({
  type: ERROR_INTRADAY_PRICING_AUTOMATIC,
  error
});

export const REQUESTED_CDS_PORTFOLIO = 'REQUESTED_CDS_PORTFOLIO';
export const requestedCDSPortfolio = () => ({
  type: REQUESTED_CDS_PORTFOLIO
});

export const RECEIVED_CDS_PORTFOLIO = 'RECEIVED_CDS_PORTFOLIO';
export const receivedCDSPortfolio = (response) => ({
  type: RECEIVED_CDS_PORTFOLIO,
  ...response
});

export const ERROR_CDS_PORTFOLIO = 'ERROR_CDS_PORTFOLIO';
export const errorCDSPortfolio = (error) => ({
  type: ERROR_CDS_PORTFOLIO,
  error
});

export const IS_PRINT_MODE = 'IS_PRINT_MODE';
export const setIsPrintMode = (isPrintMode) => {
  return {
    type: IS_PRINT_MODE,
    isPrintMode: isPrintMode
  }
};

export const REQUESTED_UNREALIZED_GAINS_LOSSES = 'REQUESTED_UNREALIZED_GAINS_LOSSES';
export const requestedUnrealizedGainsLosses = () => ({
  type: REQUESTED_UNREALIZED_GAINS_LOSSES
});

export const RECEIVED_UNREALIZED_GAINS_LOSSES = 'RECEIVED_UNREALIZED_GAINS_LOSSES';
export const receivedUnrealizedGainsLosses = (response) => ({
  type: RECEIVED_UNREALIZED_GAINS_LOSSES,
  unrealizedGainsLosses: response
});

export const ERROR_UNREALIZED_GAINS_LOSSES = 'ERROR_UNREALIZED_GAINS_LOSSES';
export const errorUnrealizedGainsLosses = (error) => ({
  type: ERROR_UNREALIZED_GAINS_LOSSES,
  error
});

// realized prior year requests
export const REQUESTED_REALIZED_GAINS_LOSSES_PRIOR = 'REQUESTED_REALIZED_GAINS_LOSSES_PRIOR';
export const requestedRealizedGainsLossesPrior = () => ({
    type: REQUESTED_REALIZED_GAINS_LOSSES_PRIOR
});

export const RECEIVED_REALIZED_GAINS_LOSSES_PRIOR = 'RECEIVED_REALIZED_GAINS_LOSSES_PRIOR';
export const receivedRealizedGainsLossesPrior = (response) => ({
    type: RECEIVED_REALIZED_GAINS_LOSSES_PRIOR,
    realizedPriorYearData: response
});

export const ERROR_REALIZED_GAINS_LOSSES_PRIOR = 'ERROR_REALIZED_GAINS_LOSSES_PRIOR';
export const errorRealizedGainsLossesPrior = (error) => ({
    type: ERROR_REALIZED_GAINS_LOSSES_PRIOR,
    error
});

// realized current year requests
export const REQUESTED_REALIZED_GAINS_LOSSES_CURRENT = 'REQUESTED_REALIZED_GAINS_LOSSES_CURRENT';
export const requestedRealizedGainsLossesCurrent = () => ({
    type: REQUESTED_REALIZED_GAINS_LOSSES_CURRENT
});

export const RECEIVED_REALIZED_GAINS_LOSSES_CURRENT = 'RECEIVED_REALIZED_GAINS_LOSSES_CURRENT';
export const receivedRealizedGainsLossesCurrent = (response) => ({
    type: RECEIVED_REALIZED_GAINS_LOSSES_CURRENT,
    realizedCurrentYearData: response
});

export const ERROR_REALIZED_GAINS_LOSSES_CURRENT = 'ERROR_REALIZED_GAINS_LOSSES_CURRENT';
export const errorRealizedGainsLossesCurrent = (error) => ({
    type: ERROR_REALIZED_GAINS_LOSSES_CURRENT,
    error
});

export const REQUESTED_WORKSPACE_PREFERENCES =
  'REQUESTED_WORKSPACE_PREFERENCES';
export const requestedWorkspacePreferences = () => ({
  type: REQUESTED_WORKSPACE_PREFERENCES
});

export const REQUESTED_UPDATE_WORKSPACE_PREFERENCES =
  'REQUESTED_UPDATE_WORKSPACE_PREFERENCES';
export const requestedUpdateWorkspacePreferences = () => ({
  type: REQUESTED_UPDATE_WORKSPACE_PREFERENCES
});

export const RECEIVED_WORKSPACE_PREFERENCES = 'RECEIVED_WORKSPACE_PREFERENCES';
export const receivedWorkspacePreferences = (workspacePreferences) => ({
  type: RECEIVED_WORKSPACE_PREFERENCES,
  preferences: workspacePreferences
});

export const RECEIVED_UPDATE_WORKSPACE_PREFERENCES =
  'RECEIVED_UPDATE_WORKSPACE_PREFERENCES';
export const receivedUpdateWorkspacePreferences = (workspacePreferences) => ({
  type: RECEIVED_UPDATE_WORKSPACE_PREFERENCES,
  preferences: workspacePreferences
});

export const ERROR_WORKSPACE_PREFERENCES = 'ERROR_WORKSPACE_PREFERENCES';
export const errorWorkspacePreferences = (error) => ({
  type: ERROR_WORKSPACE_PREFERENCES,
  error
});

export const ERROR_UPDATE_WORKSPACE_PREFERENCES =
  'ERROR_UPDATE_WORKSPACE_PREFERENCES';
export const errorUpdateWorkspacePreferences = (error) => ({
  type: ERROR_UPDATE_WORKSPACE_PREFERENCES,
  error
});

export const REDIRECTED_TO_DEFAULT_HOME_PAGE =
  'REDIRECTED_TO_DEFAULT_HOME_PAGE';
export const performedHomepageRedirect = (hasRedirected) => ({
  type: REDIRECTED_TO_DEFAULT_HOME_PAGE,
  hasRedirected
});

export const CHANGE_IRA_CONTRIBUTION_TOGGLE = 'CHANGE_IRA_CONTRIBUTION_TOGGLE';
export const changeContributionYear = (value) => ({
  type: CHANGE_IRA_CONTRIBUTION_TOGGLE,
  value
});

export const REQUESTED_CANCEL_PENDING_TRANSACTION =
  'REQUESTED_CANCEL_PENDING_TRANSACTION';
export const requestedCancelPendingTransaction = () => ({
  type: REQUESTED_CANCEL_PENDING_TRANSACTION
});

export const RECEIVED_CANCEL_PENDING_TRANSACTION =
  'RECEIVED_CANCEL_PENDING_TRANSACTION';
export const receivedCancelPendingTransaction = () => ({
  type: RECEIVED_CANCEL_PENDING_TRANSACTION
});

export const ERROR_CANCEL_PENDING_TRANSACTION =
  'ERROR_CANCEL_PENDING_TRANSACTION';
export const errorCancelPendingTransaction = (error) => ({
  type: ERROR_CANCEL_PENDING_TRANSACTION,
  error
});

export const REQUESTED_MAILING_ADDRESS = 'REQUESTED_MAILING_ADDRESS';
export const requestedMailingAddress = () => ({
  type: REQUESTED_MAILING_ADDRESS
});

export const RECEIVED_MAILING_ADDRESS = 'RECEIVED_MAILING_ADDRESS';
export const receivedMailingAddress = (mailingAddress) => ({
  type: RECEIVED_MAILING_ADDRESS,
  mailingAddress
});

export const ERROR_MAILING_ADDRESS = 'ERROR_MAILING_ADDRESS';
export const errorMailingAddress = (error) => ({
  type: ERROR_MAILING_ADDRESS,
  error
});

export const REQUESTED_RESIDENTIAL_ADDRESS = 'REQUESTED_RESIDENTIAL_ADDRESS';
export const requestedResidentialAddress = () => ({
  type: REQUESTED_RESIDENTIAL_ADDRESS
});

export const RECEIVED_RESIDENTIAL_ADDRESS = 'RECEIVED_RESIDENTIAL_ADDRESS';
export const receivedResidentialAddress = (residentialAddress) => ({
  type: RECEIVED_RESIDENTIAL_ADDRESS,
  residentialAddress
});

export const ERROR_RESIDENTIAL_ADDRESS = 'ERROR_RESIDENTIAL_ADDRESS';
export const errorResidentialAddress = (error) => ({
  type: ERROR_RESIDENTIAL_ADDRESS,
  error
});
